import { Component } from '@angular/core';

@Component({
    selector: 'pace-fi-main',
    templateUrl: './main.component.html',
    styleUrl: './main.component.scss',
    standalone: false,
})
export class MainComponent {}
